export default __webpack_public_path__ + "static/media/map.272097cc.svg";